import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import Image from "next/image";
import { forwardRef } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
interface DynamicSizeFramePropsType extends GeneralPropsType {
  width: number;
  height?: number;
  style?: any;
  onClick?: (data?: any) => any;
}
const DynamicSizeFrame = forwardRef<HTMLDivElement, DynamicSizeFramePropsType>(({
  children,
  width,
  height,
  style = {},
  className,
  onClick
}, ref) => {
  const {
    isLimitSize,
    screenSize
  } = useGlobalData();
  return <div onClick={onClick} className={clsx(`inline-block`, styles.container, className)} style={{
    aspectRatio: `${width / (height ?? width)}`,
    width: isLimitSize ? `clamp(${width}px,calc(${width / 375}*${screenSize?.realWidth / (screenSize?.width ?? 390) * 100}vw),${2 * width}px)` : `clamp(${width}px,calc(${width / 375}*100vw),${2 * width}px)`,
    minWidth: width + "px",
    minHeight: height + "px",
    ...style
  }} ref={ref}>
                {children}
            </div>;
});
DynamicSizeFrame.displayName = "DynamicSizeFrame";
export default DynamicSizeFrame;